import { render, staticRenderFns } from "./configuration-templates-synoptic-templates-modal-basic-form.vue?vue&type=template&id=3f8a1960&scoped=true&"
import script from "./configuration-templates-synoptic-templates-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-templates-synoptic-templates-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-templates-synoptic-templates-modal-basic-form.scss?vue&type=style&index=0&id=3f8a1960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a1960",
  null
  
)

export default component.exports